import { combineReducers } from 'redux'
import { ICompany, IStandardSetting } from '../types/company'
import { IDepartment, IPosition } from '../types/department'
import { IEmployee, IInvolvementEmployees } from '../types/employee'
import { IRight } from '../types/right'
import { IRole } from '../types/role'
import { IPagination } from '../../../types/pagination'
import { IPositionBillingRate } from './../types/department'
import { department, departmentActivePage, departments, departmentsPagination, employeesToDepartment, filterDepartments, openDepartmentForm, sortDepartments } from './departments'
import {
  employeeActivePage,
  employeePagination,
  employees,
  filterEmployees,
  involvementEmployees,
  openEmployeeForm,
  openPaginatedProjectEmployees,
  openProjectEmployees,
  paginatedEmployeeActivePage,
  paginatedInvolvementEmployeeActivePage,
  paginatedInvolvementEmployees,
  selectedEmployee,
  sortEmployees
} from './employees'
import { companies, company, standardSetting, standardSettings } from './globalSettings'
import { modifiedPosBillingRate, selectedPosition } from './positionBillingRates'
import { filterRoles, openRolForm, rights, roleActivePage, roles, rolesPagination, selectedRole, sortRoles } from './roles'


export interface UserSettingsState {
  departments: IDepartment[]
  department: IDepartment
  sortDepartments: { name: string, direction: string }
  employeesToDepartment: IEmployee[]
  employees: IEmployee[]
  company: ICompany
  companies: ICompany[]
  standardSetting: IStandardSetting
  standardSettings: IStandardSetting[]
  sortEmployees: { name: string, direction: string }
  filterEmployees: string
  employeePagination: IPagination<IEmployee[]>
  selectedEmployee: IEmployee
  openEmployeeForm: boolean
  selectedRole: IRole
  openRolForm: boolean
  roles: IRole[]
  sortRoles: { name: string, direction: string }
  openDepartmentForm: boolean
  selectedPosition: IPosition
  modifiedPosBillingRate: IPositionBillingRate
  employeeActivePage: number
  departmentActivePage: number
  filterDepartments: string
  departmentsPagination: IPagination<IDepartment[]>
  rolesPagination: IPagination<IRole[]>
  roleActivePage: number
  filterRoles: string
  openProjectEmployees: IEmployee[]
  openPaginatedProjectEmployees: IPagination<IEmployee[]>
  involvementEmployees: IInvolvementEmployees[]
  rights: IRight[]
  paginatedEmployeeActivePage: number
  paginatedInvolvementEmployees: IPagination<IInvolvementEmployees[]>
  paginatedInvolvementEmployeeActivePage: number
}

const userSettingsApp = combineReducers<UserSettingsState>({
  departments,
  department,
  sortDepartments,
  employees,
  company,
  companies,
  standardSetting,
  standardSettings,
  sortEmployees,
  filterEmployees,
  employeePagination,
  roles,
  sortRoles,
  selectedEmployee,
  openEmployeeForm,
  selectedRole,
  openRolForm,
  employeesToDepartment,
  openDepartmentForm,
  selectedPosition,
  modifiedPosBillingRate,
  employeeActivePage,
  departmentActivePage,
  filterDepartments,
  departmentsPagination,
  rolesPagination,
  filterRoles,
  roleActivePage,
  openProjectEmployees,
  involvementEmployees,
  rights,
  openPaginatedProjectEmployees,
  paginatedEmployeeActivePage,
  paginatedInvolvementEmployees,
  paginatedInvolvementEmployeeActivePage
})

export default userSettingsApp
